import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useGetOnboardingRequestByTokenQuery } from '../slices/onboardingApiSlice';
import Loader from '../components/Loader';

const OnboardingPdfScreen = () => {
  const { token } = useParams();
  const { data: request, isLoading, error } = useGetOnboardingRequestByTokenQuery(token);

  useEffect(() => {
    if (request && request.formData) {
      setTimeout(() => {
        window.print();
      }, 500);
    }
  }, [request]);

  if (isLoading) return <Loader />;
  if (error || !request?.formData) return <div className="alert alert-danger">Error loading form data.</div>;

  const data = request.formData;

  const Field = ({ label, value, fullWidth }) => (
    <div style={{ marginBottom: '16px', display: 'flex', flexDirection: fullWidth ? 'column' : 'row', alignItems: fullWidth ? 'flex-start' : 'flex-end', pageBreakInside: 'avoid' }}>
      <div style={{ fontWeight: 600, width: fullWidth ? '100%' : '280px', flexShrink: 0, fontSize: '14px', color: '#444', marginBottom: fullWidth ? '10px' : '0' }}>{label}</div>
      <div style={{ flexGrow: 1, width: fullWidth ? '100%' : 'auto', borderBottom: '1px solid #999', minHeight: '24px', fontSize: '14px', padding: '0 5px', whiteSpace: 'pre-wrap' }}>
        {value || ' '}
      </div>
    </div>
  );

  return (
    <div style={{ backgroundColor: '#ffffff', minHeight: '100vh', padding: '40px', fontFamily: 'Arial, sans-serif' }}>
      <div style={{ maxWidth: '850px', margin: '0 auto' }}>
        <div style={{ display: 'flex', alignItems: 'center', borderBottom: '3px solid #0055a4', paddingBottom: '20px', marginBottom: '30px' }}>
          <div style={{ flexGrow: 1 }}>
            <h1 style={{ margin: 0, color: '#0055a4', fontSize: '28px' }}>Diocese of Camden</h1>
            <h2 style={{ margin: '8px 0 0 0', color: '#555', fontSize: '18px', fontWeight: 'normal' }}>Managed IT Services - Parish Onboarding Form</h2>
            <div style={{ marginTop: '10px', fontSize: '14px', color: '#666' }}>Submitted: {new Date(request.submittedAt).toLocaleString()}</div>
          </div>
        </div>

        <div style={{ marginBottom: '25px' }}>
          <h3 style={{ marginTop: 0, borderBottom: '2px solid #eee', paddingBottom: '10px', color: '#0055a4', fontSize: '18px' }}>1. Parish & Contact Information</h3>
          <Field label="Parish Name:" value={data.parish_name} />
          <Field label="Address:" value={data.address} />
          <Field label="Primary IT Contact / Liaison:" value={data.primary_contact} />
          <Field label="Title/Role:" value={data.contact_title} />
          <Field label="Phone Number:" value={data.phone} />
          <Field label="Email Address:" value={data.email} />
          <Field label="Current IT Support Structure:" value={data.current_support} fullWidth />
        </div>

        <div style={{ marginBottom: '25px' }}>
          <h3 style={{ marginTop: 0, borderBottom: '2px solid #eee', paddingBottom: '10px', color: '#0055a4', fontSize: '18px' }}>2. User & Device Count</h3>
          <Field label="Total Staff/Employee Count:" value={data.staff_count} />
          <Field label="Active Workstations (Total):" value={data.workstations} />
          <Field label="Desktops:" value={data.desktops} />
          <Field label="Laptops:" value={data.laptops} />
          <Field label="Mobile/Tablets:" value={data.mobile} />
          <Field label="Printers/Copiers:" value={data.printers} />
        </div>

        <div style={{ marginBottom: '25px' }}>
          <h3 style={{ marginTop: 0, borderBottom: '2px solid #eee', paddingBottom: '10px', color: '#0055a4', fontSize: '18px' }}>3. Network Infrastructure</h3>
          <Field label="ISP & Bandwidth (Up/Down):" value={data.isp} />
          <Field label="Firewall (Brand/Model/Age):" value={data.firewall} />
          <Field label="Switches (Brand/Model/PoE?):" value={data.switches} />
          <Field label="Wireless (Brand/Controller/APs):" value={data.wireless} />
        </div>

        <div style={{ marginBottom: '25px', pageBreakInside: 'avoid' }}>
          <h3 style={{ marginTop: 0, borderBottom: '2px solid #eee', paddingBottom: '10px', color: '#0055a4', fontSize: '18px' }}>4. Server, Cloud & Software Environment</h3>
          <Field label="Physical Servers (Specs/Age):" value={data.servers} />
          <Field label="Virtualization (Hyper-V / VMware):" value={data.virtualization} />
          <Field label="Email/Cloud (M365 / Google Workspace):" value={data.cloud} />
          <Field label="Domain Registrar (e.g., GoDaddy):" value={data.registrar} />
          <Field label="Parish Management Software 1:" value={data.software1} fullWidth />
          <Field label="Parish Management Software 2:" value={data.software2} fullWidth />
        </div>

        <div style={{ marginBottom: '25px', pageBreakInside: 'avoid' }}>
          <h3 style={{ marginTop: 0, borderBottom: '2px solid #eee', paddingBottom: '10px', color: '#0055a4', fontSize: '18px' }}>5. Security & Continuity</h3>
          <Field label="Backup Solution (Local & Offsite):" value={data.backup} />
          <Field label="Antivirus / EDR Solution:" value={data.antivirus} />
          <Field label="MFA / 2FA Enforced?:" value={data.mfa} />
          <Field label="Physical Security (Server Room / Rack):" value={data.physical_sec} />
        </div>

        <div style={{ marginBottom: '25px', pageBreakInside: 'avoid' }}>
          <h3 style={{ marginTop: 0, borderBottom: '2px solid #eee', paddingBottom: '10px', color: '#0055a4', fontSize: '18px' }}>6. Current Challenges & Goals</h3>
          <Field label="What are the biggest IT pain points or challenges currently?" value={data.pain_points} fullWidth />
          <Field label="Additional Notes / Special Requirements:" value={data.notes} fullWidth />
        </div>
      </div>
    </div>
  );
};

export default OnboardingPdfScreen;
